"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Section_NextTab: "Move to next FastTab",
                Section_nthTab: "Move to nth FastTab",
                Section_PrevTab: "Move to previous FastTab",
            },
        });
        /**
         * Container for vertically arranged pages.
         */
        var Section = /** @class */ (function (_super) {
            __extends(Section, _super);
            function Section() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Section.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.LayoutWidth = $dyn.ui.tabWidth(this);
                this.LayoutHeight = $dyn.ui.tabHeight(this);
                this.LayoutMinHeight = { minSizeFunction: $dyn.layout.gridLayoutMinHeight, cssClassArgument: "section" };
                this.pages = [];
                this.CanCollapseAll = $dyn.observable(true);
                // Has to be defined witin init() because we need the this context for the contextMenu command
                this.CollapseAll = function () {
                    _this.setAllExpandedState(false);
                };
                this.CanExpandAll = $dyn.observable(true);
                // Has to be defined witin init() because we need the self context for the contextMenu command
                this.ExpandAll = function () {
                    _this.setAllExpandedState(true);
                };
            };
            /**
             * Registers a new section page in section control
             * @param page The section page which is added as a child of this section container.
             */
            Section.prototype.RegisterSectionPage = function (page) {
                // If the new page is always expanded fasttab then we need to remove reflow scope from tabpages
                // since always expanded fasttabs are size to available and expanding/collapsing other pages changes the the always expanded fasttab height.
                if ($dyn.value(page.FastTabExpanded) === $dyn.controls.SectionPage.FastTabExpandedState.Always &&
                    this.hasAlwaysExpandedPage !== true) {
                    this.hasAlwaysExpandedPage = true;
                    // Remove reflow scope from all previously added pages
                    this.pages.forEach(function (p) {
                        $dyn.layout.provider.removeScopeMarker(p.element);
                    });
                }
                // If an always expanded fasttab exist then remove reflow scope
                if (this.hasAlwaysExpandedPage) {
                    $dyn.layout.provider.removeScopeMarker(page.element);
                }
                this.pages.push(page);
            };
            /**
             * Handler for keyDown events
             * @param event The keydown event that occurred.
             */
            Section.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            /**
             * Navigate to a tab page relatve to the given tab page.
             * @param direction Integer indicating the relative position to navigate to (eg, -1 = previous tab, +1 = next tab).
             * @param fromTabPage The page to navigate from.
             */
            Section.prototype.NavigateTab = function (direction, fromTabPage) {
                var children = $dyn.value(this.pages);
                var childCount = children.length;
                // find next/previous tab index applying roll over
                var getTargetTabIdx = function (currentTabIndex) {
                    return (((currentTabIndex + direction) % childCount) + childCount) % childCount;
                };
                var targetTabIdx = -1;
                for (var activeTabIdx = 0; activeTabIdx < childCount; activeTabIdx++) {
                    if (children[activeTabIdx].Name === fromTabPage) {
                        targetTabIdx = getTargetTabIdx(activeTabIdx);
                        // find next/previous visible tab
                        while (!$dyn.value(children[targetTabIdx].Visible)) {
                            targetTabIdx = getTargetTabIdx(targetTabIdx);
                        }
                        break;
                    }
                }
                if (targetTabIdx >= 0) {
                    children[targetTabIdx].Activate();
                }
            };
            /**
             * Navigate to a tab page relatve to the given tab page.
             * @param tabPageIndex - Positive integer (or 0) indicating the index to navigate to.
             * @returns True if we navigated, false otherwise.
             */
            Section.prototype.Activate_nth_TabPage = function (tabPageIndex) {
                var e_1, _a;
                var children = $dyn.value(this.pages);
                var childCount = children.length;
                if (tabPageIndex >= 0 && tabPageIndex < childCount) {
                    var visibleCount = 0;
                    try {
                        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                            var child = children_1_1.value;
                            if ($dyn.value(child.Visible)) {
                                if (visibleCount === tabPageIndex) {
                                    child.Activate();
                                    return true;
                                }
                                visibleCount++;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return false;
            };
            /**
             * Sets the Expanded state for all child pages.
             * @param newState True to set expanded, false to set collapsed.
             */
            Section.prototype.setAllExpandedState = function (newState) {
                var e_2, _a;
                try {
                    for (var _b = __values(this.pages), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var page = _c.value;
                        // Convert 0 or 1 value to boolean
                        var currentExpandedState = $dyn.value(page.Expanded) ? true : false;
                        if ($dyn.value(page.FastTabExpanded) !== $dyn.controls.SectionPage.FastTabExpandedState.Always && currentExpandedState !== newState) {
                            $dyn.applyFunction(page.ExpandedChanged, page);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            };
            return Section;
        }($dyn.ui.Container));
        controls.Section = Section;
        Section.prototype.Width = $dyn.layout.Size.available;
        Section.prototype.Height = $dyn.layout.Size.available;
        // tslint:disable:object-literal-sort-keys
        var sectionShortcuts = {
            PreviousTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function (evt) {
                    var tabpageName = $dyn.context($(evt.target).closest(".section-page")[0]).Name;
                    return this.NavigateTab(-1, tabpageName);
                },
                Description: $dyn.label("Section_PrevTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            NextTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function (evt) {
                    var tabpageName = $dyn.context($(evt.target).closest(".section-page")[0]).Name;
                    return this.NavigateTab(1, tabpageName);
                },
                Description: $dyn.label("Section_NextTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            nthTab: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.numbers },
                Handler: function (evt) {
                    var tabIndex = evt.which - $dyn.ui.KeyCodes.Number1;
                    return this.Activate_nth_TabPage(tabIndex);
                },
                Description: $dyn.label("Section_nthTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
        };
        Section.prototype.Shortcuts = $dyn.extendPrototype(Section.prototype.Shortcuts, sectionShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Section.js.map
